<template>
  <div class="NeighborhoodControl mb-3">
    <!-- <p class="pl-3 ml-3 pr-4">
      Selecteer een buurt
    </p> -->
    <div 
      class="pl-3 ml-3 mr-3 ">
      <Form
        class="d-flex w-100"
        @submit="() => null">
        <FormField 
          class="w-100"
          v-model="neighborhoodModel"
          v-bind="neighborhood" />
      </Form>
      <div class="mt-2 text-right" >
        <router-link :to="{ name: 'neighborhood-information', params: { slug: activeNeighborhoodSlug } }">
          Bekijk de buurt informatie
        </router-link>
      </div>
    </div>
    
  </div>
</template>

<script>
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'NeighborhoodControl',
  components: { 
    Form, FormField
  },
  data() {
    return {
      neighborhood: {
        type: 'select',
        label: null,
        novalidate: true,
        options: []
      },
    }
  },
  computed: {
    ...mapGetters('map', [
      'getLoadedStatus'
    ]),
    ...mapGetters('geodata', ['hasNeighborhoodBuildingData']),
    ...mapGetters('filters', [
      'getActiveNeighborhood', 
      'getActiveMunicipalityInfo', 
      'getActiveMunicipality', 
      'getActiveNeighborhoodInfo'
    ]),
    neighborhoodModel: {
      get() {
        return this.getActiveNeighborhood
      },
      set (neighborhood) {
        this.setNeighborhood({ neighborhood })
        this.setHighlighted({ pand_id: false }) // This resets the building inspector

        if (! this.hasNeighborhoodBuildingData({ neighborhood })) {
          this.getBuurtPandInfo({ neighborhood: this.getActiveNeighborhoodInfo })
        }
      }
    },
    activeNeighborhoodName() {
      return this.getActiveNeighborhoodInfo.label
    },
    activeNeighborhoodSlug() {
      return this.getActiveNeighborhoodInfo.slug
    }
  },
  created() {
    this.neighborhood.options = Object.values(this.getActiveMunicipalityInfo.neighborhoods).map(option => {
      return { text: option.label, value: option.id }
    })

    if (! this.hasNeighborhoodBuildingData({ neighborhood: this.getActiveNeighborhood })) {
      this.getBuurtPandInfo({ neighborhood: this.getActiveNeighborhoodInfo })
    }
  },
  methods: {
    ...mapMutations('filters', [
      'setNeighborhood',
    ]),
    ...mapActions('geodata', [
      'getBuurtPandInfo'
    ]),
    ...mapMutations('map', [
      'setHighlighted'
    ])
  }
}
</script>

<style lang="scss">

.NeighborhoodControl {
  // border-bottom: 1px solid rgba(0, 0, 0, 0.125);

  .form-group {
    margin-bottom: 0;
  }


  h5 {
    span {
      width: 55px;
      display: inline-block;
    }
  }
}
</style>